/*
 * delivery-eta.js (HYPEST)
 * Berekent de bezorgbelofte in de NL-tijdzone (Europe/Amsterdam) en toont
 * een leesbare NL-zin + (waar zinnig) een live-aftellende cutoff.
 *
 * Regels (eigenaar):
 *   - Cutoff 22:00. Besteld vóór 22:00 op een verzenddag (ma-za) => VANDAAG verzonden.
 *   - NL-levertijd 1-2 werkdagen.
 *   - Ma-vr vóór 22:00 => vandaag verzonden, morgen/overmorgen in huis + countdown.
 *   - Za vóór 22:00 => verzonden, komt maandag aan (geen bezorging op zondag).
 *   - Zo (hele dag) + vr/za ná 22:00 => eerstvolgende verzenddag = maandag.
 *
 * We werken met de NL-wandklok van de bezoeker (via Intl + Europe/Amsterdam),
 * zodat de cutoff klopt ongeacht de browser-tijdzone.
 */
(function () {
  'use strict';

  var TZ = 'Europe/Amsterdam';
  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

  // Geef de huidige NL-wandklok als {weekday:0-6 (0=zo), hour, minute, second}.
  function nlNow() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
    var parts = {};
    fmt.formatToParts(new Date()).forEach(function (p) {
      parts[p.type] = p.value;
    });
    var wdMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var hour = parseInt(parts.hour, 10);
    if (hour === 24) hour = 0; // sommige engines geven '24' voor middernacht
    return {
      weekday: wdMap[parts.weekday],
      hour: hour,
      minute: parseInt(parts.minute, 10),
      second: parseInt(parts.second, 10),
    };
  }

  // 0=zo ... 6=za. Verzenddagen = ma-za (1..6). Bezorging niet op zondag.
  function isShippingDay(wd) {
    return wd >= 1 && wd <= 6;
  }

  // Resultaat: { sentence, countdownTarget } ; countdownTarget = seconden tot 22:00 of null.
  function computeEta(now, cutoffHour) {
    var wd = now.weekday;
    var beforeCutoff =
      now.hour < cutoffHour || (now.hour === cutoffHour && now.minute === 0 && now.second === 0);
    // Strikt: vóór 22:00 betekent klok < 22:00:00.
    beforeCutoff = now.hour < cutoffHour;

    var secondsToCutoff =
      (cutoffHour * 3600) - (now.hour * 3600 + now.minute * 60 + now.second);

    var isEn = (document.documentElement.lang === 'en' || (window.Shopify && window.Shopify.locale === 'en'));
    if (wd >= 1 && wd <= 4 && beforeCutoff) {
      return {
        sentence: isEn ? 'Shipped today — delivered in 1–2 business days.' : 'Vandaag verzonden — morgen of overmorgen in huis.',
        countdownTarget: secondsToCutoff,
      };
    }

    if ((wd === 5 || wd === 6) && beforeCutoff) {
      return {
        sentence: isEn ? 'Shipped today — delivered Monday.' : 'Vandaag verzonden — maandag in huis.',
        countdownTarget: secondsToCutoff,
      };
    }

    if (wd === 0 || ((wd === 5 || wd === 6) && !beforeCutoff)) {
      return {
        sentence: isEn ? 'Shipped Monday — delivered Tuesday.' : 'Maandag verzonden — dinsdag in huis.',
        countdownTarget: null,
      };
    }

    if (wd >= 1 && wd <= 4 && !beforeCutoff) {
      return {
        sentence: isEn ? 'Shipped tomorrow — delivered in 1–2 business days.' : 'Morgen verzonden — daarna 1–2 werkdagen in huis.',
        countdownTarget: null,
      };
    }

    return {
      sentence: isEn ? 'Ships on business days — delivery in 1–2 business days.' : 'Verzending op werkdagen — NL-levertijd 1–2 werkdagen.',
      countdownTarget: null,
    };
  }

  function formatCountdown(totalSeconds) {
    if (totalSeconds == null || totalSeconds <= 0) return '';
    var isEn = (document.documentElement.lang === 'en' || (window.Shopify && window.Shopify.locale === 'en'));
    var h = Math.floor(totalSeconds / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    if (isEn) {
      if (h > 0) {
        return 'Order within ' + h + 'h ' + m + 'm for same-day shipping';
      }
      var s = totalSeconds % 60;
      return 'Order within ' + m + 'm ' + s + 's for same-day shipping';
    }
    if (h > 0) {
      return 'Bestel binnen ' + h + 'u ' + m + 'm voor verzending vandaag';
    }
    var s = totalSeconds % 60;
    return 'Bestel binnen ' + m + 'm ' + s + 's voor verzending vandaag';
  }

  function render(el) {
    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    if (isNaN(cutoffHour)) cutoffHour = 22;

    var textEl = el.querySelector('[data-delivery-eta-text]');
    if (!textEl) return;

    var now = nlNow();
    var eta = computeEta(now, cutoffHour);

    var html = eta.sentence;
    var cd = formatCountdown(eta.countdownTarget);
    if (cd) {
      html += ' <span class="delivery-eta__countdown" data-delivery-eta-countdown>' + cd + '</span>';
    }
    textEl.innerHTML = html;
  }

  function tick(el) {
    var cdEl = el.querySelector('[data-delivery-eta-countdown]');
    // Als de countdown er niet (meer) is, doe een volledige re-render
    // (cutoff kan net verstreken zijn -> zin wijzigt).
    render(el);
  }

  function init() {
    var nodes = document.querySelectorAll('[data-delivery-eta]');
    if (!nodes.length) return;

    nodes.forEach(function (el) {
      if (el.dataset.deliveryEtaInit === '1') return;
      el.dataset.deliveryEtaInit = '1';
      render(el);
      // Eens per seconde verversen voor de live-countdown.
      setInterval(function () {
        tick(el);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Cart-drawer wordt soms async (her)gerenderd -> opnieuw initialiseren.
  document.addEventListener('cart:refresh', init);
  document.addEventListener('shopify:section:load', init);
})();
